<template>
  <b-container fluid>
    <b-card>
        <input class="btn btn-default btn-file" type="file" id="formFile" ref="myFile" @change="selectedFile">
    </b-card>
    <b-card>
      <b-row>
        <b-col><b>Date:</b> {{ dPeriod | formatDatePeriod }}</b-col>
      </b-row>
    </b-card>

    <b-table
      responsive
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="results"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      class="table-romeflex"
    >
      <template #cell(deliveryPeriod)="data">
        {{ data.item.deliveryPeriod }}
      </template>
       <template #cell(direction)="data">
        {{ data.item.direction }}
      </template>
      <template #cell(resourceGroup)="data">
        {{ data.item.resourceGroup }}
      </template>
      <template #cell(bidId)="data">
        {{ data.item.bidId }}
      </template>
      <template #cell(price)="data">
        {{ data.item.price }}
      </template>
      <template #cell(quantity)="data">
        {{ data.item.quantity }}
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="results.length"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </b-container>
</template>

<style>
.btn-sm, .btn-group-sm > .btn {
    padding: 0.25rem 0.25rem;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 0.2rem;
}
.create-button {
  margin-bottom: 20px;
  background-color: #af0f6a;
}
.mf-1{
  color: #fff;
  background-color: #bd277c;
}
.line-chart {
  height : 300px;
}
.btn-file {
    position: relative;
    overflow: hidden;
}
.btn-file input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    background: white;
    cursor: inherit;
    display: block;
}

</style>

<script>
import convert from 'xml-js'

export default {
  components: {
  },
  mounted () {
    // this.getFileXml()
  },
  data () {
    return {
      options: {
        responsive: true
      },
      sortBy: 'start',
      sortDesc: true,
      results: [],
      dPeriod: null,
      fields: [
        { key: 'deliveryPeriod', label: 'Delivery Period', sortable: true },
        { key: 'direction', label: 'Direction', sortable: true },
        { key: 'product', label: 'Product', sortable: true },
        { key: 'resourceGroup', label: 'Resource Group', sortable: true },
        { key: 'bidId', label: 'Bid ID', sortable: true },
        { key: 'price', label: 'Price', sortable: true },
        { key: 'quantity', label: 'Quantity', sortable: true }
      ],
      currentPage: 1,
      perPage: 10,
      file: ''
    }
  },
  methods: {
    getFileXml (xml) {
      let array = []
      this.xmlContent = null
      this.xmlError = false

      this.xmlContent = xml
      let json = JSON.parse(convert.xml2json(xml, {compact: true, ignoreDeclaration: true, spaces: 4}))
      let points = json.MeritOrderList_MarketDocument.TimeSeries.Period.Point
      let periodStart = json.MeritOrderList_MarketDocument.TimeSeries.Period.timeInterval.start._text
      const d = new Date(periodStart)
      let hour = d.getUTCHours()
      let minutes = d.getUTCMinutes()
      minutes = ('0' + minutes).slice(-2)
      const bidID = json.MeritOrderList_MarketDocument.TimeSeries['marketAgreement.mRID']._text

      this.dPeriod = new Date(periodStart)

      if (points && !points.length) {
        points = [points]
      }

      for (let i = 0; i < points.length; i++) {
        let deliveryPeriod = ''
        if (i === 0) {
          deliveryPeriod = hour.toString().concat(':').concat(minutes).concat(' - ').concat((hour + 1).toString()).concat(':').concat(minutes)
        } else {
          deliveryPeriod = (hour + i).toString().concat(':').concat(minutes).concat(' - ').concat((hour + (i + 1)).toString()).concat(':').concat(minutes)
        }
        const obj = {
          deliveryPeriod: deliveryPeriod,
          direction: 'Up',
          product: 'MFRR',
          resourceGroup: 'FSP3_RG_test_1',
          bidId: bidID,
          price: points[i]['price.amount']._text,
          quantity: points[i]['quantity.quantity']._text
        }
        array.push(obj)
      }
      console.log('RESULT' + JSON.stringify(array))

      this.results = array
    },
    selectedFile () {
      console.log('selected a file')
      console.log(this.$refs.myFile.files[0])

      let file = this.$refs.myFile.files[0]
      if (!file || file.type !== 'text/xml') return

      let reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      reader.onload = evt => {
        console.log('1', evt.target.result)
        this.getFileXml(evt.target.result)
      }
      reader.onerror = evt => {
        console.error(evt)
      }
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/EnlintDemo.vue